import React from 'react';

import { Box } from '@material-ui/core';

import animationData from 'assets/check.json';
import Lottie from 'react-lottie';
import styled from 'styled-components';

import Button from 'components/atoms/Button';
import Text from 'components/atoms/Text';

import { SkuModelReference } from 'types/sku-model-reference';
import { SkuSku } from 'types/sku-sku';
import { SparePartType } from 'types/spare-part';
import { Supplier } from 'types/supplier';

const StyledContainer = styled.div((props) => ({
  display: 'inline-grid',
  width: '100%',
  height: 'calc(100% - 57px)',
  padding: `0 ${props.theme.space[3]}px`,
  boxSizing: 'border-box',
}));

const BottomButton = styled(Button)((props) => ({
  bottom: props.theme.space[2],
  position: 'absolute',
  width: '90%',
}));

const animationOptions = {
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
const TextButton = styled.div((props) => ({
  textDecoration: 'underline',
  color: props.theme.colors.grey900,
  fontSize: props.theme.fontSizes[2],
  marginTop: props.theme.space[6],
}));

type ConfirmationContainerProps = {
  skuSku: SkuSku;
  supplier: Supplier;
  reference: string;
  setSkuSku: (skuSku: SkuSku | undefined) => void;
  onSkuModelValidation: (skuSku: SkuSku, supplier: Supplier, reference: string) => void;
};

const ConfirmationContainer: React.FunctionComponent<ConfirmationContainerProps> = ({
  skuSku,
  supplier,
  reference,
  setSkuSku,
  onSkuModelValidation,
}: ConfirmationContainerProps) => {
  const displayType = (type: SparePartType) => {
    switch (type) {
      case 'new':
        return 'NEUF';
      case 'second_hand':
        return 'OCCASION';
    }
  };
  return (
    <StyledContainer>
      <Box mt={20}>
        <Lottie options={animationOptions} height={130} width={130} />
      </Box>
      <div>
        <Text variant="title1" mt={1}>
          {skuSku?.designation}
        </Text>
        <Text variant="title1" mt={1}>
          {displayType(skuSku.type)}
        </Text>
        {skuSku.references.map((reference: SkuModelReference, index: number) => (
          <Text key={index} variant="body" mt={3}>
            {reference.supplier_name} {reference.reference}
          </Text>
        ))}
      </div>
      <TextButton onClick={() => setSkuSku(undefined)}>Modifier la sélection</TextButton>
      <BottomButton
        variant="primary"
        onClick={() => onSkuModelValidation(skuSku, supplier, reference)}
        minWidth={192}
      >
        Confirmer
      </BottomButton>
    </StyledContainer>
  );
};

export default ConfirmationContainer;
